module.exports = __webpack_public_path__ + "static/media/faq_white-01.bd28e043.svg";